
// src/routes/AppRoutes.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { rolePages } from "../roles";

import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import GuestRoute from "./GuestRoute";
import LayoutSwitcher from "../Layout/LayoutSwitcher";
import DevicePage from "../hooks/DevicePage";

// الصفحات
import Login from "../Auth/Login";
import Dashboard from "../pages/Dashboard";
import POS from "../pages/PosPage/POS";
import MobilePOS from "../pages/PosPage/MobilePOS";
import TabletPOS from "../pages/PosPage/TabletPOS";
import MenuManagement from "../pages/MenuManagement";
import Customers from "../pages/Customers";
import Invoices from "../pages/Invoices";
import Reports from "../pages/Reports";
import EmployeePage from "../pages/EmployeePage";
import UsersManagement from "../pages/UsersManagement";
import Settings from "../pages/Settings";
import Accounts from "../pages/Accounts";
// شاشة الطاولات
import TablesSectionDesktop from "../components/PagesComponents/PosSection/PosPageTaps/TablesSectionTap/TablesSectionDesktop";
import TablesSectionMobile from "../components/PagesComponents/PosSection/PosPageTaps/TablesSectionTap/MobileTablesSection";
import TablesSectionTablet from "../components/PagesComponents/PosSection/PosPageTaps/TablesSectionTap/TabletTablesSection";
// شاشة الديلفري
import DeliverySectionDesktop from "../components/PagesComponents/PosSection/PosPageTaps/DeliverySectionTap/DeliverySection";
import DeliverySectionMobile from "../components/PagesComponents/PosSection/PosPageTaps/DeliverySectionTap/MobileDeliverySection";
import DeliverySectionTablet from "../components/PagesComponents/PosSection/PosPageTaps/DeliverySectionTap/TabletDeliverySection";
// شاشة التيكواي
import TakeawaySectionDesktop from "../components/PagesComponents/PosSection/PosPageTaps/TakeawaySectionTap/TakeawaySection";
import TakeawaySectionMobile from "../components/PagesComponents/PosSection/PosPageTaps/TakeawaySectionTap/MobileTakeawaySection";
import TakeawaySectionTablet from "../components/PagesComponents/PosSection/PosPageTaps/TakeawaySectionTap/TabletTakeawaySection";


import ReservationSection from "../components/PagesComponents/PosSection/PosPageTaps/ReservationSectionTap/ReservationSection";
import ReportStatistics from "../components/PagesComponents/ReportsComponents/ReportStatistics/ReportStatistics";

import CustomerMenu from "../pages/publicPegas/CustomerMenuPage/CustomerMenuMainPage";
import CustomerOrderTableMenu from "../pages/publicPegas/CustomerOrderTableMenu/CustomerOrderTableMenu";
import Deliverypage from "../pages/DeliveryUserpage";
import TaghezScreen from "../components/PagesComponents/Settings/Taghez/TaghezScreen";
import { getStepComponent, getProfileStep, isAuthenticated } from "./helpers";
import KitchensSetup from "../components/SetupAccountOperations/KitchensSetup";
import GeneralInfo from "../components/SetupAccountOperations/GeneralInfo";
import Branches from "../components/SetupAccountOperations/Branches";
import TablesSetup from "../components/SetupAccountOperations/TablesSetup";
import StorageSetup from "../components/SetupAccountOperations/StorageSetup";


const AppRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) return null;

  const role = user?.type;
  const allowedPages = role ? rolePages[role] || [] : [];

  return (
    <Routes>
      {/* 🌍 Guest routes */}
      <Route
        path="/menu/:tableCode"
        element={
          <GuestRoute>
            <CustomerOrderTableMenu />
          </GuestRoute>
        }
      />
      <Route
        path="/ourmenu"
        element={
          <GuestRoute>
            <CustomerMenu />
          </GuestRoute>
        }
      />


      {/* 🔓 Auth */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      {/* 🔒 Setup */}
      <Route
        path="/setup/*"
        element={
          <PrivateRoute>
          <Navigate to={`/setup/${getStepComponent(getProfileStep())}`} />
          </PrivateRoute>
        }
      />
      <Route
        path="/setup/general-info"
        element={
          <PrivateRoute>
            <GeneralInfo />
          </PrivateRoute>
        }
      />
      <Route
        path="/setup/branches"
        element={
          <PrivateRoute>
            <Branches />
          </PrivateRoute>
        }
      />
      <Route
        path="/setup/tables"
        element={
          <PrivateRoute>
            <TablesSetup />
          </PrivateRoute>
        }
      />
      <Route
        path="/setup/storages"
        element={
          <PrivateRoute>
            <StorageSetup />
          </PrivateRoute>
        }
      />
      <Route
        path="/setup/kitchens"
        element={
          <PrivateRoute>
            <KitchensSetup />
          </PrivateRoute>
        }
      />

      {/* 🔒 Main Layout */}
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <LayoutSwitcher>
              <Routes>
                {allowedPages.includes("/dashboard") && (
                  <Route path="/dashboard" element={<Dashboard />} />
                )}

                {allowedPages.includes("/pos") && (
                  <Route
                    path="/pos"
                    element={
                      <DevicePage
                        desktop={<POS />}
                        tablet={<TabletPOS />}
                        mobile={<MobilePOS />}
                      />
                    }
                  />
                )}

                {allowedPages.includes("/invoices") && (
                  <Route path="/invoices" element={<Invoices />} />
                )}

                {allowedPages.includes("/reports") && (
                  <Route path="/reports" element={<Reports />} />
                )}

                {allowedPages.includes("/Statics") && (
                  <Route path="/Statics" element={<ReportStatistics />} />
                )}

                {allowedPages.includes("/customers") && (
                  <Route path="/customers" element={<Customers />} />
                )}

                {allowedPages.includes("/menu") && (
                  <Route path="/menu" element={<MenuManagement />} />
                )}

                {allowedPages.includes("/staff") && (
                  <Route path="/staff" element={<EmployeePage />} />
                )}

                {allowedPages.includes("/users") && (
                  <Route path="/users" element={<UsersManagement />} />
                )}

                {allowedPages.includes("/settings") && (
                  <Route path="/settings" element={<Settings />} />
                )}

                {allowedPages.includes("/accounts") && (
                  <Route path="/accounts" element={<Accounts />} />
                )}

                {allowedPages.includes("/tables") && (
                  <Route
                    path="/tables"
                    element={
                      <DevicePage
                        desktop={<TablesSectionDesktop />}
                        tablet={<TablesSectionTablet />}
                        mobile={<TablesSectionMobile />}
                      />
                    }
                  />
                )}

                {allowedPages.includes("/delivery") && (
                  <Route
                    path="/delivery"
                    element={
                      <DevicePage
                        desktop={<DeliverySectionDesktop />}
                        tablet={<DeliverySectionTablet />}
                        mobile={<DeliverySectionMobile />}
                      />
                    }
                  />
                )}

                {allowedPages.includes("/takeaway") && (
                  <Route
                    path="/takeaway" 
                    element={
                    <DevicePage
                        desktop={<TakeawaySectionDesktop />}
                        tablet={<TakeawaySectionTablet />}
                        mobile={<TakeawaySectionMobile />}
                      />
                     } 
                    />
                )}

                {allowedPages.includes("/reservation") && (
                  <Route path="/reservation" element={<ReservationSection />} />
                )}

                {/* fallback */}
                <Route
                  path="*"
                  element={
                    <Navigate to={allowedPages[0] || "/login"} replace />
                  }
                />
              </Routes>
            </LayoutSwitcher>
          </PrivateRoute>
        }
      />

      {/* 📦 خارج الـ Layout */}
      {allowedPages.includes("/Deliverypage") && (
        <Route
          path="/Deliverypage"
          element={
            <PrivateRoute>
              <Deliverypage />
            </PrivateRoute>
          }
        />
      )}

      {allowedPages.includes("/TaghezScreen") && (
        <Route
          path="/TaghezScreen"
          element={
            <PrivateRoute>
              <TaghezScreen />
            </PrivateRoute>
          }
        />
      )}
    </Routes>
  );
};

export default AppRoutes;
